import React from "react";

export function BehavioralGoalsRatingLabelButtons(props) {
  const { isEditing, onClick, optionLabelMap, progress, ratingKey } = props;

  let answerKey = ratingKey ? ratingKey : "answer";

  let optionLabelMapValues = Object.values(optionLabelMap);

  return (
    <div className="col-12 d-flex justify-content-start" style={{ padding: 0 }}>
      {Object.keys(optionLabelMap).map((optionId, index) => {
        optionId = parseInt(optionId);
        let optionsClasses;

        if (progress[answerKey] !== null && progress[answerKey] === optionId) {
          optionsClasses = "RatingOptionButton RatingOptionButton-active w-100";
        } else {
          optionsClasses =
            "RatingOptionButton w-100 " + (props.optionsClasses ? props.optionsClasses : "");
        }

        return (
          <div className="w-100" key={progress.label + optionId} style={{ margin: "0px 5px" }}>
            <button
              className={optionsClasses}
              disabled={!isEditing}
              id={`${optionId}`}
              onClick={onClick}
              style={{ height: 30 }}
              type="button"
              value={optionId}
            >
              {" "}
              {optionLabelMapValues[index]}{" "}
            </button>
          </div>
        );
      })}
    </div>
  );
}
